import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

@customElement('bh-participation-modify-actions')
export class BHAdminModifyActions extends ChemistryLitElement {
  @state() protected readonly _translation = new TranslationController<BHTranslationDictionary>(this);

  override render() {
    return html`
      <x-flex horizontal space-between crossaxis-center wrap space="md">
        <x-button
          mode="outline"
          @click=${() => {
            this.dispatchEvent(new CustomEvent('cancel', { composed: true }));
          }}
        >
          ${this._translation.translate('discard')}
        </x-button>
        <x-button
          @click=${() => {
            this.dispatchEvent(new CustomEvent('save'));
          }}
        >
          ${this._translation.translate('save')}
        </x-button>
      </x-flex>
    `;
  }
}
